export const WEEK_TAB = "Week";
export const MONTH_TAB = "Month";
export const DEFAULT_TABS = [WEEK_TAB, MONTH_TAB];
export const ERROR_MESSAGE = "Sorry, an error occurred while we tried to calculate this chart";
export const LOADING_MESSAGE = "Please wait while we calculate this chart";
export const EMPTY_STATE_MESSAGE = "Not enough data to show this chart";
export const DEFAULT_COLOURS: Array<string> = [
	"var(--charts-first-data-point)",
	"var(--charts-second-data-point)",
	"var(--charts-third-data-point)",
	"var(--charts-fourth-data-point)",
	"var(--charts-fifth-data-point)",
	"var(--charts-sixth-data-point)",
];
export const INNER_DEFAULT_COLOURS: Array<string> = ["var(--first-peach-section)", "var(--second-peach-section)"];
